
export default class NavSearch {

  constructor(root) {
    this.root = root;
    this.searchForm = document.getElementById(root.getAttribute('aria-owns'));
    this.toggled = false;

    this.updateDOM = this.updateDOM.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
  }

  updateDOM() {
    const ariaLabel = `${ this.toggled ? 'hide' : 'show' } search form`;

    this.root.setAttribute('aria-expanded', this.toggled);
    this.root.setAttribute('aria-label', ariaLabel);
    this.searchForm.setAttribute('aria-hidden', !this.toggled);
  }

  toggleSearch() {
    this.toggled = !this.toggled;

    this.updateDOM();
  }

  init() {
    this.updateDOM();

    this.root.addEventListener('click', this.toggleSearch);
  }

};



// WEBPACK FOOTER //
// ./components/nav-search.js